export default __webpack_public_path__ + "static/media/phone.001266b8.svg";